<template>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 pull-left">
                <h2>Uptime report</h2>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 pull-right text-right">
                <h2>
                    <a
                        @click.prevent="previuosMonth()"
                        v-if="reportData.prev"
                        class="report-navigation"
                    >
                        <icon name="angle-left" class="icon"></icon>
                    </a>
                    <small class="month-year__label text-right">{{ reportData.date | monthYear }}</small>
                    <a
                        @click.prevent="nextMonth()"
                        v-if="reportData.next"
                        class="report-navigation"
                    >
                        <icon name="angle-right" class="icon"></icon>
                    </a>
                </h2>
            </div>
        </div>
        <hr style="margin-top:0px;" />
        <div>
            <div class="bootstrap-iso">
                <div class="container-fluid">
                    <div
                        class="row"
                        v-for="component in reportData.components"
                        v-bind:key="component.name"
                    >
                        <h3>{{ component.name }}</h3>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 report-info">
                            <h2 class="pull-left">
                                <small>Uptime</small>
                            </h2>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <uptime-chart
                                :uptime="component.uptime"
                                :downtime="component.downtime"
                                :height="100"
                            ></uptime-chart>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 report-info">
                            <h2 class="pull-left">
                                <small>Incidents list</small>
                            </h2>
                            <br />
                            <div class="row" v-if="component.incidents.length > 0">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th>Date</th>
                                                <th class="text-right">Duration</th>
                                                <th class="text-right">Service down</th>
                                                <th class="text-right">Scheduled</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                class="incidents-list-rows"
                                                :class="{ active : isRowActive(incident.startDate, component.name) }"
                                                v-for="incident in component.incidents"
                                                v-bind:key="incident.id"
                                            >
                                                <td>
                                                    <router-link :to="`/incidents/${incident.id}`">
                                                        <icon name="calendar" class="icon"></icon>
                                                        <span
                                                            class="icon-label"
                                                        >On {{ incident.startDate | date }}</span>
                                                    </router-link>
                                                </td>
                                                <td
                                                    class="text-right"
                                                    v-if="incident.downtime >= 0"
                                                >{{ incident.downtime }} min</td>
                                                <td class="text-right" v-else>Unresolved</td>
                                                <td
                                                    class="text-right"
                                                >{{ incident.componentDown ? 'Yes' : 'No' }}</td>
                                                <td
                                                    class="text-right"
                                                >{{ incident.scheduled ? 'Yes' : 'No' }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div v-else>
                                <div
                                    class="col-lg-12 col-md-12 col-sm-12 col-xs-12 report-info alert alert-info"
                                >
                                    <p>There are no incidents reported for {{ component.name }} component for {{ reportData.date | monthYear }}.</p>
                                </div>
                            </div>
                        </div>
                        <div
                            class="col-lg-12 col-md-12 col-sm-12 col-xs-12 report-info"
                            v-if="component.incidents.length > 0"
                        >
                            <incident-chart
                                :labels="component.chartData.labels"
                                :uptime="component.chartData.uptime"
                                :downtime="component.chartData.downtime"
                                :scheduled-downtime="component.chartData.scheduledDowntime"
                                :height="70"
                                v-on:highlight="selectedDate(...arguments, component.name)"
                            ></incident-chart>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UptimeChart from "./UptimeChart";
import IncidentChart from "./IncidentChart";
import { mapGetters, mapActions } from "vuex";
import store from "../store";
import moment from "moment";

export default {
    name: "Index",
    components: {
        UptimeChart: UptimeChart,
        IncidentChart: IncidentChart
    },
    data() {
        return {
            activeDate: null,
            activeComponent: null
        };
    },
    computed: {
        ...mapGetters({
            reportData: "getReportData"
        })
    },
    methods: {
        ...mapActions({
            loadReportData: "loadReportData"
        }),
        nextMonth() {
            if (this.reportData.next) {
                this.loadReportData(this.reportData.next);
            }
        },
        previuosMonth() {
            if (this.reportData.prev) {
                this.loadReportData(this.reportData.prev);
            }
        },
        selectedDate(date, component) {
            this.activeDate = date;
            this.activeComponent = component;
        },
        isRowActive(date, component) {
            return (
                this.activeDate === moment.utc(date).format("MMM Do") &&
                this.activeComponent === component
            );
        }
    },
    beforeRouteEnter(to, from, next) {
        store.dispatch("loadReportData").then(res => next());
    }
};
</script>

<style scoped>
.report-navigation {
    cursor: pointer;
    padding: 0 15px;
}
a:hover {
    text-decoration: none;
}
.month-year__label {
    display: inline-block;
    width: 150px;
    text-align: center;
    user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Report.vue